import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { SlotGameType1 } from "../SlotGameType1";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class LuckyFire extends SlotGameType1 {
	protected override panelFactory: IPanelFactory = new LuckyFirePanelFactory();
	protected override helpFactory: IHelpFactory = new LuckyFireHelpFactory();
	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "white",
			coloroutherStroke: "black",
			colorinnerStroke: "darkred",
		}
	//LED COLOR
	protected override ColorLed: string = "250,0,0\n";
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "LuckyFire");
		this.spinnableReelsParams.topBorderWidth = 21;
		this.spinnableReelsParams.bottomBorderWidth = 13;
	}

	protected override colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg, rgb(13, 38, 34),rgb(13, 38, 34), rgb(26,115,99),rgb(13, 38, 34),rgb(13, 38, 34)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
}

//Panel Colorized
class LuckyFirePanelFactory implements IPanelFactory {
	public CreateNewPanel(params: PanelParams): Panel {
		return new LuckyFirePanel(params);
	}
}

class LuckyFirePanel extends Panel {
	protected override ButtonBackground(): ButtonColors {
		let color: ButtonColors = {
			backgroundButtonColor: "linear-gradient(rgb(13, 38, 34),rgb(13, 38, 34), rgb(26,115,99),rgb(13, 38, 34),rgb(13, 38, 34)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
		};
		return color;
	}

}

class LuckyFireHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new LuckyFireHelp(params);
	}
}

class LuckyFireHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(13, 38, 34),rgb(13, 38, 34), rgb(26,115,99),rgb(13, 38, 34),rgb(13, 38, 34)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
		return color;
	}
}	